import { humanize } from '@/lib/humanize';

/**
 * Renders a single schema field generically based on its JS type.
 * Returns null for missing/empty values so sparse records render cleanly.
 */
export default function Field({ label, value, chips = true }) {
  if (value === undefined || value === null || value === '') return null;

  if (Array.isArray(value)) {
    if (value.length === 0) return null;
    return (
      <div className="field">
        <div className="field__label">{label}</div>
        <div className="field__chips">
          {value.map((v) => (
            <span key={v} className="chip">
              {chips ? humanize(v) : v}
            </span>
          ))}
        </div>
      </div>
    );
  }

  if (typeof value === 'boolean') {
    return (
      <div className="field field--inline">
        <span className="field__label">{label}</span>
        <span className={`badge ${value ? 'badge--yes' : 'badge--no'}`}>{value ? 'Yes' : 'No'}</span>
      </div>
    );
  }

  if (typeof value === 'number') {
    return (
      <div className="field field--inline">
        <span className="field__label">{label}</span>
        <span className="field__value">{value}</span>
      </div>
    );
  }

  return (
    <div className="field">
      <div className="field__label">{label}</div>
      <p className="field__text">{value}</p>
    </div>
  );
}
